import React from 'react';
import i18n from 'i18next';
import ReactDOMServer from 'react-dom/server';
import FormatBold from '@mui/icons-material/FormatBold';
import FormatItalic from '@mui/icons-material/FormatItalic';
import FormatUnderlined from '@mui/icons-material/FormatUnderlined';
import Link from '@mui/icons-material/Link';

import { getIsCoursePublishing } from '@/exceed';

const boldIconString = ReactDOMServer.renderToString(<FormatBold sx={{ height: 18, width: 18 }} />);
const italicIconString = ReactDOMServer.renderToString(<FormatItalic sx={{ height: 18, width: 18 }} />);
const underlineIconString = ReactDOMServer.renderToString(<FormatUnderlined sx={{ height: 18, width: 18 }} />);
const anchorIconString = ReactDOMServer.renderToString(<Link sx={{ height: 18, width: 18 }} />);

export default ({ videoVersion }) => {
  const disableEditing = getIsCoursePublishing(videoVersion);

  return {
    anchor: {
      targetCheckbox: true,
      targetCheckboxText: i18n.t('open-in-new-window'),
    },
    toolbar: !disableEditing && {
      buttons: [
        {
          name: 'bold',
          contentDefault: boldIconString,
        },
        {
          name: 'italic',
          contentDefault: italicIconString,
        },
        {
          name: 'underline',
          contentDefault: underlineIconString,
        },
        {
          name: 'anchor',
          contentDefault: anchorIconString,
        },
      ],
    },
    placeholder: {
      text: i18n.t('compose-description'),
      hideOnClick: false,
    },
    disableEditing,
  };
};
